import i18n from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import cs from './cs/common.yaml'
import en from './en/common.yaml'

// namespace (default)
const namespace = 'common'

const resources = {
    cs: { common: cs },
    en: { common: en },
}

// get i18nextLng from localStorage
const lang = localStorage.getItem('i18nextLng') || navigator.language || ''

i18n
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .init({
        interpolation: {
            escapeValue: false,
        },
        lowerCaseLng: true,
        detection: {
            // order and from where user language should be detected
            order: ['localStorage', 'navigator', 'cookie'],
        },
        supportedLngs: ['cs', 'en', 'de', 'pl'],
        fallbackLng: {
            cs: ['cs'],
            en: ['cs', 'en'],
            sk: ['cs'],
            pl: ['cs', 'en'],
            default: ['en'],
        },
        lng: lang,
        ns: namespace,
        defaultNS: namespace,
        debug: false,
        resources,
    })

export default i18n
